// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__DFEN9","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3mb0V","obliqueLine":"membershipbadge_obliqueLine__2_BqV"};